'use client';

import { useEffect, useState } from 'react';
import { useAuthStore } from '@/lib/auth-store';
import { authApi } from '@/lib/api';
import { useRouter } from 'next/navigation';

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const { setUser, logout } = useAuthStore();
  const [isInitializing, setIsInitializing] = useState(true);
  const router = useRouter();

  useEffect(() => {
    let active = true;
    const initAuth = async () => {
      let redirecting = false;
      try {
        const { data } = await authApi.me();
        const userData = data.data || data;

        if (active && userData) {
          setUser(userData);
        }
      } catch (error: any) {
        if (!active) return;
        logout();

        // Use window.location to be absolutely sure of current path without hook reactivity during init
        const isAuthPage = window.location.pathname.includes('/auth/login') ||
                          window.location.pathname.includes('/auth/register');

        if (!isAuthPage) {
          redirecting = true;
          router.replace('/auth/login');
        }
      } finally {
        // Don't stop showing the spinner if we're redirecting away — mounting
        // protected children while navigation is in-flight causes a hooks
        // count mismatch ("Rendered more hooks than during the previous render").
        if (active && !redirecting) {
          setIsInitializing(false);
        }
      }
    };

    initAuth();
    return () => { active = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Run ONLY once on mount

  return (
    <>
      {isInitializing ? (
        <div className="flex items-center justify-center min-h-screen bg-gray-50">
          <div className="flex flex-col items-center gap-4">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-600"></div>
            <p className="text-gray-500 text-sm font-medium">Caricamento sessione...</p>
          </div>
        </div>
      ) : (
        children
      )}
    </>
  );
}
